import type { CustomStoreImplementationOptions, KaElementMap, MergeCustomStore, StoreIdentifier } from 'kapix-components-vue3'
import { defineStore } from 'pinia'
import { initAliveStoreIds, kapixContext, navigateTo, openUrl, remove, scrollInfo } from 'kapix-components-vue3'
import expertRessourcesEvaluationsStoreCustom from './store.custom'
import { $translate } from '~/modules/i18n'

const storeName = 'expertRessourcesEvaluations'
const customImplement: CustomStoreImplementationOptions = expertRessourcesEvaluationsStoreCustom.options
const aliveStoreIds = initAliveStoreIds()

function expertRessourcesEvaluationsFactory (storeId?: Nullable<StoreIdentifier>) {
  return defineStore(storeId == null ? storeName : `${storeName}/${storeId}`, {
    state: () => {
      return {
        $aliveStoreIds: aliveStoreIds,
        $subStoreIds: 1,
        $storeId: storeId,
        $emit: (() => {}) as (propName: any, value: any) => void,
        $elements: {} as KaElementMap,
        $router: kapixContext.isClient ? kapixContext.$router : undefined,
        $route: kapixContext.isClient ? kapixContext.$route : undefined,
        // Page info,
        $title: $translate('expert-ressource-7-evaluation.title', 'Évaluations de fin de formation'),
        $description: $translate('expert-ressource-7-evaluation.description', 'Votre première formation en tant que formateur occasionnel se termine et vous devez créer les évaluations pour les apprenants. Retrouvez dans cette page toutes les différences et les points communs entre l\'évaluation des acquis théoriques et l\'évaluation des acquis pratiques.'),
        $publishedTime: new Date('2023-08-01T13:10:04.774Z'),
        $modifiedTime: new Date('2023-09-05T10:22:15.818Z'),
        // Constants,
        $constants: { parDefautIlY5: 'Par défaut, il y<strong> 5 séquences de 2 questions</strong>. Vous pouvez ajouter ou supprimer des séquences et/ou des <strong>questions par séquence </strong>en utilisant le menu de droite.<br> <br>De plus, pour chaque question, il faut <strong>paramétrer les réponses</strong> afin que le stagiaire puisse accéder aux son évaluation à l\'issue du questionnaire. Vous pourrez accéder aux <strong>paramétrages des résultats </strong>en cliquant sur "Corrigé" (bouton entouré en rouge ci-dessous).' },
        // Data,
        $info: { expertRessource7Evaluation: scrollInfo() },
        ...(customImplement.state && customImplement.state())
      }
    },
    getters: {
      ...customImplement.getters
    },
    actions: {
      /* @ts-ignore: to allow override in your custom file */
      async toutesLesRessourcesClick () {
        await navigateTo({ name: 'hub-expert-Ressources' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async envoyerUnQcmDevaluationClick () {
        await navigateTo({ hash: '#evaluer-les-apprentissages--p122' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async renseignerLesMisesClick () {
        await navigateTo({ hash: '#evaluer-les-apprentissages--p122' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async previewRessourceShortClick () {
        await navigateTo({ name: 'hub-expert-Ressources-construire-support-de-formation' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async element1Click () {
        await navigateTo({ name: 'Expert-Ressources-posture-du-formateur' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async element2Click () {
        await navigateTo({ name: 'Expert-Ressources-animer-la-formation' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async jeMinscrisClick () {
        await navigateTo({ name: 'Parrainage' })
      },
      /* @ts-ignore: to allow override in your custom file */
      jeMinscrisClickOnSm () {
        openUrl('https://www.matchers.fr/experts', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      jeMinscrisClickOnXs () {
        openUrl('https://www.matchers.fr/experts', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        return storeId != null ? getStoreInstance(storeId) : this
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstances () {
        return aliveStoreIds.map(storeId => this.getStoreInstance(storeId))
      },
      /* @ts-ignore: to allow override in your custom file */
      newStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        const newStoreId = storeId || this.$subStoreIds++
        if (aliveStoreIds.includes(newStoreId)) {
          throw new Error(`Store with id ${storeId} already exists`)
        }
        aliveStoreIds.push(newStoreId)
        return getStoreInstance(newStoreId)
      },
      ...customImplement.actions,
      /* @ts-ignore: to allow override in your custom file */
      beforeMount () {
        customImplement.actions?.beforeMount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      mounted () {
        customImplement.actions?.mounted?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      async serverPrefetch () {
        await customImplement.actions?.serverPrefetch?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      beforeUnmount () {
        customImplement.actions?.beforeUnmount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      unmounted () {
        if (this.$storeId != null) {
          this.$dispose()
          remove(aliveStoreIds, this.$storeId)
        }
        customImplement.actions?.unmounted?.call(this)
      }
    }
  })
}

function getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
  return expertRessourcesEvaluationsFactory(storeId)()
}

export const expertRessourcesEvaluationsRaw = expertRessourcesEvaluationsFactory()
export const expertRessourcesEvaluations = () => expertRessourcesEvaluationsRaw() as MergeCustomStore<typeof expertRessourcesEvaluationsStoreCustom.instance>
